import { Container } from '@connected/ui/layouts/container';
import { useTranslation } from 'react-i18next';

import {
    InformationLine,
    InformationLineText,
} from '@/components/information-line';

import type { SummaryReport } from '../utils/summary-information-types';

import { IB22Remarks } from './ib22-remarks';

const KIND_LABELS: Record<string, string> = {
    Scope8: 'Scope 8',
    Scope10: 'Scope 10',
    Scope12: 'Scope 12',
    Nen1010: 'NEN 1010',
    Nen3140: 'NEN 3140',
};

export type ReportCardProps = {
    report: SummaryReport;
};

export function ReportCard({ report }: ReportCardProps) {
    const { t } = useTranslation('re-inspections');

    return (
        <Container>
            <Container.Header>
                <Container.Title>
                    {KIND_LABELS[report.InspectionKind ?? ''] ?? report.InspectionKind ?? 'Rapport'}
                </Container.Title>
            </Container.Header>
            <Container.Content>
                <div className="flex flex-col gap-2">
                    <InformationLine
                        label={InformationLineText(t('recap.form.verdict'))}
                        value={
                            report.IsFinalVerdictPassed === true
                                ? 'Voldoet'
                                : report.IsFinalVerdictPassed === false
                                    ? 'Voldoet niet'
                                    : 'Nog niet bekend'
                        }
                    />
                    <InformationLine
                        label={InformationLineText(t('recap.form.nextInspection'))}
                        value={
                            report.NextInspectionInYearCount
                                ? `${report.NextInspectionInYearCount} jaar`
                                : 'Nog niet bekend'
                        }
                    />
                    <InformationLine
                        label={InformationLineText(t('recap.form.remarks'))}
                        value={(
                            <IB22Remarks
                                observations={report.Observations || []}
                            />
                        )}
                    />
                </div>
            </Container.Content>
        </Container>
    );
}
